module.exports = __webpack_public_path__ + "img/t3-blue.8b46a6f2.png";